import BalloonEditor from './BalloonEditor';
import DecoupledEditor from './DecoupledEditor';

export default {
  BalloonEditor,
  DecoupledEditor,
};
